import { Checkbox, FormField, Heading, Layout, Select, Card } from '@vwfs-bronson/bronson-react';

import { SELECT_OPTIONS } from './constants.js';
import { isHiddenPath } from './utils.js';
import { Section } from './Section.jsx';
import { ConfigurationField } from './ConfigurationField.jsx';

export const renderConfigurationNode = (node, path, onChange, applicationControls) => {
  if (Array.isArray(node)) {
    if (node.length === 0) {
      return <p className="u-m-none">Sin elementos</p>;
    }

    return node.map((item, index) => (
      <Card key={`${path.join('_')}_${index}`} className="u-mb-small" element="article">
        <Heading level={5} className="u-mt-none u-mb-small">
          {`${path[path.length - 1]} #${index + 1}`}
        </Heading>
        {renderConfigurationNode(item, [...path, index], onChange, applicationControls)}
      </Card>
    ));
  }

  if (node !== null && typeof node === 'object') {
    const keys = Object.keys(node).filter((key) => !isHiddenPath([...path, key]));

    if (keys.length === 0) {
      return <p className="u-m-none">Objeto vacío</p>;
    }

    return (
      <Layout>
        {keys.map((key) => {
          const nextPath = [...path, key];
          const value = node[key];
          const isNested = value !== null && (Array.isArray(value) || typeof value === 'object');

          return (
            <Layout.Item key={nextPath.join('.')} default="1/2" s="1/1">
              {path.join('.') === 'Header' && key === 'Application' ? (
                <Layout>
                  <Layout.Item default="2/3" s="1/1">
                    <FormField
                      labelForId="header_application"
                      labelText="Application"
                      type="select"
                      noFloatingLabel
                    >
                      <Select
                        id="header_application"
                        value={applicationControls.baseValue}
                        onChange={(event) => applicationControls.onBaseChange(event.target.value)}
                      >
                        {(SELECT_OPTIONS['Header.Application'] || []).map((option, index) => (
                          <Select.Item
                            key={`header_application_${index}`}
                            value={String(option.value)}
                          >
                            {option.label}
                          </Select.Item>
                        ))}
                      </Select>
                    </FormField>
                  </Layout.Item>
                  <Layout.Item default="1/3" s="1/1">
                    <Checkbox
                      id="header_application_is_canarias"
                      name="IsCanarias"
                      checked={applicationControls.withPrefixC}
                      onChange={(event) =>
                        applicationControls.onTogglePrefix(event.target.checked)
                      }
                    >
                      IsCanarias
                    </Checkbox>
                  </Layout.Item>
                </Layout>
              ) : isNested ? (
                <Section title={key}>
                  {renderConfigurationNode(value, nextPath, onChange, applicationControls)}
                </Section>
              ) : (
                <ConfigurationField
                  fieldPath={nextPath}
                  fieldLabel={key}
                  value={value}
                  onChange={onChange}
                />
              )}
            </Layout.Item>
          );
        })}
      </Layout>
    );
  }

  return null;
};